import { UserStatus } from "@ctypes";
import { useUser } from "@hooks";
import { i18n, Translations } from "@i18n";
import { Intercom } from "@services";
import { BankLinkingErrorBanner } from "./BankLinkingErrorBanner";
import { InProgressBanner } from "./InProgressBanner";
import { VerificationErrorBanner } from "./VerificationErrorBanner";
import { VerificationInProgressBanner } from "./VerificationInProgressBanner";

export const AccountStatusSection = () => {
  const { user, loading } = useUser();

  const handleContactSupport = () => {
    Intercom.showChat();
  };

  if (loading || !user) {
    return null;
  }

  // Custodian-neutral copy, so it covers the Capital Group 529 migration unchanged.
  if (user?.settings?.capitalGroupMigrationInProgress) {
    return (
      <InProgressBanner
        title={i18n.t(Translations.AccountStatusSectionTitle)}
        subtitle={i18n.t(Translations.AccountStatusSectionSubtitle)}
        ctaTitle={i18n.t(Translations.AccountStatusSectionPrimaryCTA)}
        ctaOnClick={handleContactSupport}
      />
    );
  }

  if (
    user?.status &&
    [UserStatus.VerificationInProgress, UserStatus.Pending, UserStatus.New].includes(user.status)
  ) {
    return <VerificationInProgressBanner />;
  }

  if (user?.status === UserStatus.VerificationFailed) {
    return <VerificationErrorBanner />;
  }

  if (user?.settings?.plaidRelinkBannerEnabled) {
    return <BankLinkingErrorBanner />;
  }

  return null;
};
